import { EmailData } from "@/modules/Email/models/EmailData";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { NotificationParams } from "./NotificationParams";
import { NotificationTemplate } from "./NotificationTemplate";

export class Message {
  title!: string;
  body!: string;
  multimedia?: MultimediaSelected;
  type?: string;
  video?: MultimediaSelected;
  image?: MultimediaSelected;
  button_params?: string[];
  file?: string;
  latitude?: string;
  longitude?: string;
  template?: NotificationTemplate | string;
  originalTemplate?: NotificationTemplate | string;
  params?: NotificationParams[];
  phone?: string;
  email?: string;
  emailSender?: string | EmailData;
  category?: string;
  url?: string;
  webhook?: string;
  formFields?: string[];
}
